import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import useInputs from '../../../utils/hooks/useInputs.js'
import CenterNavLinks from './nav/CenterNavLinks.tsx'
import CenterService from '../../../services/centers/center.service.js'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions.js'
import DataTableComp from '../../../components/common/data-table/DataTableComp.jsx'
import Modal from '../../../components/modal/Modal.jsx'
import useModal from '../../../utils/hooks/useModal.js'
import CenterConventionForm from './form/CenterConventionForm.tsx'
import { urlBack } from './utils/center.utils.ts'
import AppSection from '../../../component/layout/AppSection.tsx'
import CenterTypeLinks from './nav/CenterTypeLinks.tsx'

const CenterConventions = () => {
  const { formatMessage: msg } = useIntl()

  const { isShowing, toggle } = useModal()
  const { id } = useParams()
  const { inputs, onChangeInputs, updateInputs } = useInputs()
  const [selectedConvention, setSelectedConvention] = useState()

  const navigate = useNavigate()

  useEffect(() => {
    getCenterData()
  }, [])
  useEffect(() => {
    if (!isShowing) dataFacade.reload()
  }, [isShowing])

  const getCenterData = async () => {
    if (id && id !== 'undefined') {
      const response = await CenterService.getById(id)
      if (response) {
        updateInputs(response.resp)
      }
    }
  }

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'name',
    getAll: () => CenterService?.conventions?.getAll(id),
  })

  const headerOptions = {
    title: inputs?.basicData?.name,
    // searchOptions: dataFacade?.searchOptions,
    handlerHeaderActions: {
      showBackButton: true,
      backButton: () => navigate(urlBack(inputs?.centerType)),

      secondaryButton: () => {
        toggle()
      },
      secondaryButtonText: 'button.add',
      secondaryButtonIcon: 'pi-plus',
    },
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        editMode: 'row',
        selectionMode: 'single',
        // selection: selectedCenterComercialData,
        onRowSelect: (e) => {
          setSelectedConvention(e?.data)
          toggle()
        },
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column sortable field="_id" header={msg({ id: 'name' })} />,
        <Column
          sortable
          field="convention.name"
          header={msg({ id: 'name' })}
        />,
        <Column
          sortable
          field="convention.description"
          header={msg({ id: 'description' })}
        />,
      ]}
    />
  )

  return (
    <AppSection
      header={<CenterTypeLinks blur />}
      subheader={<CenterNavLinks id={id} />}
      headerOptions={headerOptions}
    >
      {dataTable}
      <Modal
        isShowing={isShowing}
        hide={() => toggle({})}
        width="90%"
        maxWidth="650px"
        title={msg({ id: 'center.conventions.add' })}
        context={
          <CenterConventionForm
            centerId={id}
            hide={toggle}
            selectedItem={selectedConvention}
          />
        }
      />
    </AppSection>
  )
}

export default CenterConventions
